export default __webpack_public_path__ + "static/media/jWewNKg9ZL.0bdd8e9a.png";